import naja from 'naja';

export default class ShippingSelector {
    constructor() {
        this.initializeEvents();
        this.initSnippetListener();
    }

    static init(): void {
        // Look for ShippingSelector by checking for shipping radio inputs
        const shippingRadios = document.querySelectorAll('.shipping-radio');
        if (shippingRadios.length > 0) {
            new ShippingSelector();
        }
    }

    private initializeEvents(): void {
        this.bindShippingRadios();
        this.handleShippingChange();
    }

    private bindShippingRadios(): void {
        const shippingRadios = document.querySelectorAll<HTMLInputElement>('.shipping-radio');
        
        shippingRadios.forEach((radio) => {
            radio.addEventListener('change', () => {
                if (radio.checked) {
                    const url = radio.getAttribute('data-shipping-url');
                    if (url) {
                        // Make AJAX request to update shipping
                        naja.makeRequest('GET', url, null, {
                            history: false,
                        }).then(() => {
                            // Handle shipping change for UI updates
                            this.handleShippingChange();
                        });
                    }
                }
            });
        });
    }

    private handleShippingChange(): void {
        const shippingRadios = document.querySelectorAll<HTMLInputElement>('.shipping-radio');
        const deliverySection = document.getElementById('snippet-orderCartForm-deliveryAddress');
        const deliveryForm = document.getElementById('delivery-address-form');
        const deliveryMessage = document.getElementById('delivery-multiple-message');

        if (!deliverySection || !deliveryForm || !deliveryMessage) {
            return;
        }

        let selectedShipping = '';
        shippingRadios.forEach((radio) => {
            if (radio.checked) {
                selectedShipping = radio.value;
            }
        });

        switch (selectedShipping) {
            case 'single_address':
                // Show form, hide message, show section
                deliverySection.style.display = 'block';
                deliveryForm.style.display = 'grid';
                deliveryMessage.style.display = 'none';
                break;
            case 'multiple_addresses':
                // Hide form, show message, show section
                deliverySection.style.display = 'block';
                deliveryForm.style.display = 'none';
                deliveryMessage.style.display = 'block';
                break;
            case 'later':
                // Hide entire section
                deliverySection.style.display = 'none';
                break;
            default:
                // Default to single address behavior
                deliverySection.style.display = 'block';
                deliveryForm.style.display = 'grid';
                deliveryMessage.style.display = 'none';
        }
    }

    private initSnippetListener(): void {
        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            // Listen for any snippet containing shippingSelector
            if (event.detail.snippet.id.includes('shippingSelector')) {
                this.initializeEvents();
            }
        });
    }
}